import { bronzeSlugs, ironSlugs, silverSlugs } from '@entities/jackpot';

export const getLeague = (jackpotSlug: string) => {
  if (ironSlugs.includes(jackpotSlug)) return 'iron';
  if (bronzeSlugs.includes(jackpotSlug)) return 'bronze';
  if (silverSlugs.includes(jackpotSlug)) return 'silver';

  if (jackpotSlug === 'Final1') return 'Gold';

  if (jackpotSlug === 'Platinum') return 'Platinum';
  if (jackpotSlug === 'ActivePlayers') return 'Leaders';
  if (jackpotSlug === 'Partner') return 'Partner';

  return '-';
};
